import React from 'react';

const ITEMS = [
  'Quality Tractor Parts',
  'Reliable Service',
  'Fast Shipping',
  'Free US Shipping Over $99',
  '1-Year Warranty',
  '24/7 Tech Support',
  'OEM-Fit Guaranteed',
];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center" aria-hidden={key === 'b'}>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight px-6 text-transparent [-webkit-text-stroke:1px_rgba(248,250,247,0.35)]">
            {t}
          </span>
          <span className="text-flame text-2xl">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="editorial-marquee" className="bg-forest border-y border-white/5 py-8 overflow-hidden">
      <div className="marquee-track">
        {row('a')}
        {row('b')}
      </div>
    </div>
  );
}
